import React, { PureComponent } from 'react';
import Options from '../standardAttributes/Options';

export default class ComputerPosition extends PureComponent {
  render() {
    const { configuration, attributeName, appApi } = this.props;
    const options = appApi.config
      .getAttributeAvailableValues(attributeName, configuration)
      .filter(option => option.value !== configuration[attributeName].value);
    const optionValues = options.map(option => option.value);
    if (
      !configuration.uprights.value ||
      configuration.uprights.value === 'None'
    ) {
      const option = options[optionValues.indexOf('aboveSurfaceComputer')];
      option.disabled = true;
      option.text += ` ${option.invalidtext}`;
    }

    return <Options {...this.props} options={options} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/ComputerPosition.js